seedWebApp.controller('UserSettingDetailsController', ['$scope', 'UserSettingService', '$uibModalInstance', 'user', 'createMode', 'TranslationService', 'ContactService', 'ToastService', 'canChangePassword', function ($scope, UserSettingService, $uibModalInstance, user, createMode, TranslationService, ContactService, ToastService, canChangePassword) {
    $scope.user = user;
    $scope.createMode = createMode;
    $scope.canChangePassword = canChangePassword;

    $scope.translation = TranslationService.getActiveTranslation();

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.ok = function () {
        $uibModalInstance.close();
    };

    $scope.invite = function () {
        $scope.saving = true;
        var toastID = ToastService.createToast('', 'Usuário convidado', 5000, 'wait');
        UserSettingService.save($scope.user, function () {
            $scope.success = true;
            $scope.saving = false;
            $scope.errorDescription = null;
            ToastService.removeToast(toastID);
            ToastService.createToast('', 'Usuário convidado', 5000, 'success');
            $scope.ok();
        }, function (errorDescription) {
            $scope.saving = false;
            $scope.success = false;
            $scope.errorDescription = errorDescription.data;
            ToastService.removeToast(toastID);
            ToastService.createToast('', 'Erro ao convidar usuário', 8000, 'error');
        });
    };

    $scope.update = function () {
        $scope.saving = true;
        var toastID = ToastService.createToast('', 'Atualizando usuário', 5000, 'wait');
        UserSettingService.put($scope.user, function () {
            $scope.success = true;
            $scope.saving = false;
            $scope.errorDescription = null;
            ToastService.removeToast(toastID);
            ToastService.createToast('', 'Usuário atualizado', 5000, 'success');
            $uibModalInstance.close();
        }, function (errorDescription) {
            $scope.saving = false;
            $scope.success = false;
            $scope.errorDescription = errorDescription.data;
            ToastService.removeToast(toastID);
            ToastService.createToast('', 'Erro ao atualizar usuário', 8000, 'error');
        });
    };

    $scope.disableChange = function () {
        //if (!$scope.user.Email || !$scope.user.UserType || ($scope.user.UserType == 'NORMAL' && !$scope.user.ContactID)) {        

        var hasContacts = false;
        if ($scope.user.Contacts && $scope.user.Contacts.length > 0) {
            hasContacts = true;
        }
        if (!$scope.user.Email || !$scope.user.UserType || ($scope.user.UserType == 'NORMAL' && !hasContacts)) {
            return true;
        }            
        return false;
    };

    $scope.userTypes = [
        { Key: 'NORMAL', Value: $scope.translation.Normal },
        { Key: 'AGENT', Value: 'Agente' }
        //{ Key: 'EXTERNAL', Value: 'Externo' }
    ];

    $scope.userRoles = ['ADMIN'];

    function filterRoles() {
        if (!$scope.allUserRoles) {
            return false;
        }
        $scope.userRoles = $scope.allUserRoles.filter(function (role) {
            return (role.UserType == $scope.user.UserType);
        });
    }

    $scope.getUserRoles = function () {
        UserSettingService.getUserRoles().then(function (response) {
            $scope.allUserRoles = response.data;
            filterRoles();
        });
    };

    $scope.getUserContacts = function () {
        $scope.loadingContacts = true;
        UserSettingService.getUserContacts($scope.user.UserID).then(
            function (response) {
                $scope.loadingContacts = false;
                $scope.user.Contacts = response.data;
                if ($scope.user.Contacts.length == 0) {
                    $scope.addContact($scope.user);
                }
            },
            function () {
                $scope.loadingContacts = false;
            });
    };

    $scope.$watch('user.UserType', function (newVal, oldVal) {
        if (newVal != oldVal) {
            $scope.user.UserRoleID = null;
            $scope.user.ContactID = null;
            filterRoles();
        }
    });

    $scope.getUserRoles();
    $scope.getUserContacts();

    $scope.contactSearch = function (query) {
        return ContactService.getContactsQuery(query)
            .then(function (response) {
                return response.data.map(function (item) {
                    return item;
                });
            })
            .catch(function (err) {
                console.error(err);
            });
    };

    $scope.resendInvitation = function () {
        var toastID = ToastService.createToast('Enviando Convite...', '', 4000, 'wait');
        UserSettingService.inviteUser($scope.user.UserID).then(function (response) {
            ToastService.removeToast(toastID);
            ToastService.createToast('', 'Convite enviado', 4000, 'success');
        }, function () {
            ToastService.removeToast(toastID);
            ToastService.createToast('', 'Erro ao enviar Convite', 4000, 'error');
        });
    };

    $scope.changePasswordLink = function () {
        var toastID = ToastService.createToast('Gerando Link...', '', 4000, 'wait');
        UserSettingService.changePasswordLink($scope.user.UserID).then(function (response) {
            $scope.resetLink = response.data;
            copy($scope.resetLink);
            alert($scope.translation.CopiedToClipboard + ': ' + $scope.resetLink);
            ToastService.removeToast(toastID);
            ToastService.createToast('', 'Link Gerado', 4000, 'success');
        }, function () {
            ToastService.removeToast(toastID);
            ToastService.createToast('', 'Erro ao gerar Link', 4000, 'error');
        });
    };


    function copy (text) {
        if (window.clipboardData && window.clipboardData.setData) {
            return clipboardData.setData("Text", text);
        } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
            document.body.appendChild(textarea);
            textarea.select();
            try {
                return document.execCommand("copy");  // Security exception may be thrown by some browsers.
            } catch (ex) {
                console.warn("Copy to clipboard failed.", ex);
                return false;
            } finally {
                document.body.removeChild(textarea);
            }
        }
    }

    $scope.selectContact = function (item) {
        $scope.user.ContactID = item.Key;
        $scope.user.ContactName = item.Value;
    };
    
    $scope.selectAddContact = function (item, modelId, model) {
        console.log('selectAddContact');
        modelId = item.Key;
        model = item.Value;
    };

    $scope.addContact = function (user) {
        var contact = { UserID: user.UserID };

        user.Contacts.push(contact);
    };

    $scope.removeContact = function (user, index) {
        user.Contacts.splice(index, 1);
    };


}]);
